import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { FiUser, FiLock } from 'react-icons/fi';

const Login = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    if (userName === "123" && password === "123") {
      setError("");
      Cookies.set("userName", userName, { expires: 1 });
      Cookies.set("password", password, { expires: 1 });
      navigate("/Dailylogs");
    } else {
      setError("Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 relative overflow-hidden px-4">
      {/* Decorative Background Elements */}
      <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-primary/20 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-accent/20 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="w-full max-w-md bg-white/70 backdrop-blur-xl p-8 sm:p-12 rounded-3xl shadow-[0_8px_40px_rgba(0,0,0,0.08)] border border-white z-10 animate-fade-in">
        
        <div className="text-center mb-10">
          <div className="mx-auto w-16 h-16 bg-gradient-to-tr from-primary to-accent rounded-2xl flex items-center justify-center shadow-lg mb-6 transform transition-transform hover:scale-105">
            <span className="text-white font-bold text-2xl">VT</span>
          </div>
          <h2 className="text-3xl font-extrabold text-slate-800 tracking-tight">Welcome Back</h2>
          <p className="text-slate-500 mt-2 font-medium">Please sign in to your account</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2" htmlFor="username">
              Username
            </label>
            <div className="relative flex items-center">
              <FiUser className="absolute left-4 text-slate-400" size={20} />
              <input
                className="w-full pl-12 pr-4 py-3.5 text-slate-800 bg-white/50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary focus:bg-white transition-all duration-200 placeholder-slate-400"
                type="text"
                id="username"
                placeholder="Enter your username"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2" htmlFor="password">
              Password
            </label>
            <div className="relative flex items-center">
              <FiLock className="absolute left-4 text-slate-400" size={20} />
              <input
                className="w-full pl-12 pr-4 py-3.5 text-slate-800 bg-white/50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary focus:bg-white transition-all duration-200 placeholder-slate-400"
                type="password"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button
            className="w-full py-4 text-white font-bold bg-primary hover:bg-primaryHover rounded-xl shadow-[0_4px_14px_0_rgba(79,70,229,0.39)] transition-all duration-200 hover:shadow-[0_6px_20px_rgba(79,70,229,0.23)] hover:-translate-y-0.5 mt-2"
            type="submit"
          >
            Sign in
          </button>
          
          {error && (
            <div className="mt-4 p-3 bg-red-50 border border-red-100 rounded-xl text-center text-red-600 font-medium text-sm animate-fade-in">
              {error}
            </div>
          )}
        </form>
      </div>
      
      <p className="mt-12 text-slate-400 text-sm font-medium z-10">© {new Date().getFullYear()} VisionTrek. All rights reserved.</p>
    </div>
  );
};

export default Login;
